export default "__VITE_ASSET__Dv8_F10Z__"